import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import { api } from "@/lib/api";
import { ArrowLeft, Linkedin } from "lucide-react";

function initialsOf(name) {
  return (name || "")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0].toUpperCase())
    .join("");
}

export default function EquipoDetalle() {
  const { slug } = useParams();
  const [member, setMember] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/public/team/${slug}`)
      .then((r) => setMember(r.data))
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <PublicLayout>
        <div className="max-w-3xl mx-auto px-4 py-24 text-center">
          <h1 className="text-3xl font-bold text-[#0B0B0B]">Miembro no encontrado</h1>
          <Link to="/equipo" className="mt-6 inline-block text-[#F26A21] hover:text-[#D9541A]">← Volver al equipo</Link>
        </div>
      </PublicLayout>
    );
  }
  if (!member) return <PublicLayout><div className="max-w-3xl mx-auto px-4 py-24 text-gray-500">Cargando...</div></PublicLayout>;

  const avatarStyle = { width: 160, height: 160, backgroundColor: member.initials_color_hex || "#F26A21" };

  return (
    <PublicLayout>
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Link to="/equipo" className="inline-flex items-center gap-1 text-sm text-gray-600 hover:text-[#0B0B0B] mb-6" data-testid="back-to-team">
          <ArrowLeft className="w-4 h-4" /> Volver al equipo
        </Link>

        <div className="grid md:grid-cols-3 gap-8 items-start">
          <div className="flex justify-center md:justify-start">
            {member.photo_url ? (
              <img src={member.photo_url} alt={member.name} style={avatarStyle} className="rounded-2xl object-cover border-4 border-white shadow-lg" />
            ) : (
              <div style={avatarStyle} className="rounded-2xl flex items-center justify-center text-white font-bold border-4 border-white shadow-lg">
                <span style={{ fontSize: 56 }}>{initialsOf(member.name)}</span>
              </div>
            )}
          </div>
          <div className="md:col-span-2">
            <p className="text-xs uppercase tracking-widest text-[#F26A21] font-semibold">{member.role_title}</p>
            <h1 className="mt-2 text-3xl md:text-4xl font-bold text-[#0B0B0B] font-display" data-testid="team-member-name">
              {member.name}
            </h1>
            {member.linkedin_url && (
              <a
                href={member.linkedin_url}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-3 inline-flex items-center gap-1 text-sm text-[#F26A21] hover:text-[#D9541A]"
              >
                <Linkedin className="w-4 h-4" /> LinkedIn
              </a>
            )}
          </div>
        </div>

        <article className="mt-10 prose prose-sm max-w-none text-[#0B0B0B] leading-relaxed" data-testid="team-member-bio">
          {(member.full_bio || member.short_bio || "").split("\n\n").map((p, i) => {
            const trimmed = p.trim();
            // Bloque 3 · homologated bios use uppercase section headers as their own paragraph.
            const isHeader = /^[A-ZÁÉÍÓÚÑ][A-ZÁÉÍÓÚÑ\s·]{3,60}$/.test(trimmed);
            if (isHeader) {
              return (
                <h3
                  key={i}
                  data-testid={`bio-section-${i}`}
                  className="mt-10 mb-4 text-[11px] font-bold uppercase tracking-widest text-[#F26A21] relative pb-3 after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-12 after:h-[3px] after:bg-[#F26A21] after:rounded-full"
                >
                  {trimmed}
                </h3>
              );
            }
            return <p key={i} className="mb-4 text-[15px] leading-7">{trimmed}</p>;
          })}
        </article>
      </section>
    </PublicLayout>
  );
}
